import React, { useState } from "react";
import { createPortal } from "react-dom";
import { GraphComponent } from "../../chat/formatters/GraphFormatter";
import Button from "../Button";

export default function MobileJourneyGraphView({ graphData, theme, onViewClick }) {
  const [isOpen, setIsOpen] = useState(false);

  const renderShimmer = () => (
    <div className="w-full bg-white border border-neutral-200 shadow-sm rounded-2xl p-6 relative flex flex-col items-center justify-center overflow-hidden h-[280px]">
      {/* Background Shimmer (skeleton bars placeholder) */}
      <div className="absolute inset-x-8 bottom-8 top-12 flex items-end justify-between gap-3 opacity-10 pointer-events-none">
         <div className="w-1/5 h-1/3 bg-primary rounded-t-md animate-pulse" style={{animationDelay: '0ms'}}></div>
         <div className="w-1/5 h-2/3 bg-primary rounded-t-md animate-pulse" style={{animationDelay: '150ms'}}></div>
         <div className="w-1/5 h-full bg-primary rounded-t-md animate-pulse" style={{animationDelay: '300ms'}}></div>
         <div className="w-1/5 h-1/2 bg-primary rounded-t-md animate-pulse" style={{animationDelay: '450ms'}}></div>
         <div className="w-1/5 h-3/4 bg-primary rounded-t-md animate-pulse" style={{animationDelay: '600ms'}}></div>
      </div>
      
      {/* Overlay content */}
      <div className="relative z-10 flex flex-col items-center">
        <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-3">
          <span className="material-symbols-outlined text-primary text-2xl">insights</span>
        </div>
        <h4 className="text-neutral-800 font-bold mb-1">Academic Journey</h4>
        <p className="text-neutral-500 text-xs mb-5 text-center px-4">Interactive graph comparing subject performances across years</p>
        <Button variant="outline" size="sm" onClick={() => setIsOpen(true)}>
           View Full Graph
        </Button>
      </div>
    </div>
  );

  return (
    <>
      {/* Always render shimmer in the normal DOM flow so height doesn't collapse */}
      {renderShimmer()}

      {/* When open, render a full screen dialog using Portal to escape all constraints */}
      {isOpen && createPortal(
        <div className="fixed inset-0 z-[9999] bg-white flex flex-col pt-safe-top animate-fade-in">
          <div className="flex justify-between items-center p-4 border-b border-neutral-100 bg-white shadow-sm z-10 shrink-0">
            <h3 className="font-extrabold text-neutral-800 text-lg">Academic Journey</h3>
            <button 
              onClick={() => setIsOpen(false)}
              className="w-10 h-10 rounded-full bg-neutral-100 flex items-center justify-center text-neutral-600 hover:bg-neutral-200 transition-colors"
            >
              <span className="material-symbols-outlined">close</span>
            </button>
          </div>
          
          {/* Maximum space for graph, completely unbound from original page padding */}
          <div className="w-full flex-grow overflow-x-auto overflow-y-hidden bg-white pb-6 pt-4">
            <div className="min-w-[650px] w-full h-full flex flex-col px-4">
              <GraphComponent graphData={graphData} theme={theme} enableAnimation />
            </div>
          </div>
        </div>,
        document.body
      )}
    </>
  );
}
